/* eslint-disable default-param-last */
export const initialState = {
  isInSickLeave: false,
  displayDigitalIdInfo: false,
};

export const initialResourceState = {
  list: [],
  detail: null,
};

export const getResourceState = (state = initialState, resource) => {
  const currentState = state[resource] || initialResourceState;
  return currentState;
};

export const getList = (state = initialState, resource) =>
  getResourceState(state, resource).list;

export const getDetail = (state = initialState, resource) =>
  getResourceState(state, resource).detail;

export const getUserProfile = (state = initialState, resource) =>
  getResourceState(state, resource).detail;

export const getSickLeaveInfo = (state = initialState) =>
  state.isInSickLeave || initialState.isInSickLeave;

export const getDigitalIdInfo = (state = initialState) =>
  state.displayDigitalIdInfo || initialState.displayDigitalIdInfo;
